module.exports = __webpack_public_path__ + "static/media/singing_bird.25504446.gif";